module.exports = __webpack_public_path__ + "img/29_43.58245685.png";